/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { useLatestHighlights, useMatchesToday } from '../hooks/matches';
import { UserContext } from '../context/user-context';
import { DataContext } from '../context/data-context';

function VideoCard({ item }) {
  const { playVideo } = useContext(UserContext);
  const { video, homeTeamName, visitingTeamName } = item;
  const { title, description } = video;

  return (
    <div
      className="video__item text-decoration-none"
      onClick={() => playVideo(video)}
    >
      <img src={video?.thumbnail} alt="" />
      <div className="video__info">
        <p className="text-small text-color-primary-yellow text-uppercase fw-bold">
          {`${homeTeamName} - ${visitingTeamName}`}
        </p>
        <p className="heading-h5 text-transform-none">{title}</p>
        <p className="text-small fw-bold">{description}</p>
      </div>
    </div>
  );
}

function LatestHighlights() {
  const { league, currentSeason } = useContext(DataContext);
  const [matchesToday] = useMatchesToday();
  const [highlights] = useLatestHighlights();

  if (matchesToday?.length > 0 && highlights?.length > 0) {
    return (
      <section className="row mb-5">
        <div className="col-12 d-flex px-sm-4 align-items-center mb-4">
          <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
            SENASTE HÖJDPUNKTERNA
          </h2>
          <a
            className="button button--primary-blue ml-auto"
            href={`https://fotbollplay.se/highlights?team=${league}&season=${currentSeason}`}
            title="Fotbollplay"
            target="_blank"
          >
            <span className="me-1 d-inline-block">Se mer</span>
            <span className="d-none d-sm-inline-block">från fotboll Play</span>
          </a>
        </div>
        <div className="col-12 px-md-0">
          <div className="video__container video__container--carousel">
            {highlights.map((v) => (
              <VideoCard key={v.key} item={v} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return null;
}

export default LatestHighlights;
